import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3InternalLinksCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <div>
          <h2>Key points</h2>
          <p>
             Search engines list your pages by following links, so linking to yourself is key. 
          </p>
          <hr />
          <h2>How it's used</h2>
          <ul>
            <li>Used by search engines to find pages</li>
            <li>Even if clicking a link in your browser works, it might not work for a search engine if that link is in Flash, created by Javascript, or goes to a different domain name</li>
          </ul>
          <hr />
          <h2>Best practice</h2>
          <ul>
            <li>Link to yourself extensively</li>
            <li>Keep a single domain where all your pages are found: a link from example.com to example.myshopify.com will not be treated as an internal link</li>
            <li>Don't make your site navigation Flash or Javascript reliant</li>
          </ul>
          <hr />
        </div>

        <div>
          <h2>Fix this yourself</h2>
          <h3>Simple navigation</h3>
          <p>
            Are your links within Flash or Javascript content? Plain HTML links are much more followable by search engines. Speak with your web developer to change this. 
          </p>
          <h3>Single domain</h3>
          <p>
            Select a primary domain where all of your pages are. If you have example.mywebsitehost.com and example.co.uk, but your primary domain is example.com, permanently redirect both these domains to example.com.
          </p>
          <ol>
            <li>In your Shopify admin…</li>
            <li>Preferences > DNS & Domains</li>
            <li>Select 'Make Primary' next to your primary domain</li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3InternalLinksCheck.js